"use client";

import React from "react";
import ModalComponentPickerExample from "@/examples/modals/ModalComponentPickerExample";

export default function ModalCardPickerPage() {
  return (
    <div className="container mx-auto p-6">
      <ModalComponentPickerExample />
    </div>
  );
}
